import React from 'react';

// Chakra imports
import { Flex, Heading, useColorModeValue, Image } from '@chakra-ui/react';

// Custom components

import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex align="center" direction="column">
      {/* ✅ Logo Image */}
      <Image
        src="/logo.png" // 👈 yaha apna image path daal
        alt="Logo"
        boxSize="100px"
        objectFit="contain"
        mb="10px"
      />

      <Heading as="h2" fontSize="2xl" color={logoColor} my="32px">
        Codon Admin
      </Heading>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
